var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meeting.fridge && _vm.meeting.fridge.length)?_c('div',[_c('strong',[_vm._v("Points d'attention reportés :")]),_vm._v(" "),_c('ul',_vm._l((_vm.meeting.fridge),function(issue){return _c('li',{key:issue.id},[_c('span',[_vm._v(_vm._s(issue.title))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }